import { ClosedPeriodModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../ui-kit';

interface RelationIds {
  compartmentId: number;
  dockId: number;
}

export class ClosedPeriodItemLoad {
  public static readonly type = '[ClosedPeriodItem] Load';

  constructor(
    public payload: RelationIds & {
      closedPeriodId: number;
    },
  ) {}
}

export class ClosedPeriodItemCreate {
  public static readonly type = '[ClosedPeriodItem] Create';

  constructor(
    public payload: RelationIds & {
      data: ClosedPeriodModel;
      dialog: MatDialogRef<unknown>;
    },
  ) {}
}

export class ClosedPeriodItemUpdate {
  public static readonly type = '[ClosedPeriodItem] Update';

  constructor(
    public payload: RelationIds & {
      data: ClosedPeriodModel;
      dialog: MatDialogRef<unknown>;
    },
  ) {}
}

export class ClosedPeriodItemDelete {
  public static readonly type = '[ClosedPeriodItem] Delete';

  constructor(
    public payload: RelationIds & {
      closedPeriodId: number;
      dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>;
    },
  ) {}
}

export class ClosedPeriodItemInitialState {
  public static readonly type = '[ClosedPeriodItem] Set Initial State';
}
